module.exports = __webpack_public_path__ + "img/icn_brand18_black.a2ecb982.svg";